(function() {
  window.addEventListener('show-element', () => {
    const startYourTrialSection = document.querySelector('.start-your-trial-section');
    if (startYourTrialSection) {
      startYourTrialSection.classList.add('start-your-trial-section-show');
    }
  });
})();
